// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay[data-v-4c06ec2d]{width:100%;height:100%;position:absolute;top:0;left:0;background-color:var(--overlay-bg);z-index:1}.ui-links-setting P[data-v-4c06ec2d]{line-height:1.25;margin-bottom:10px}.ui-links-setting .underline[data-v-4c06ec2d]{text-decoration:underline}.action[data-v-4c06ec2d]{display:flex}.action input[data-v-4c06ec2d]{margin-right:5px}", ""]);
// Exports
module.exports = exports;
